import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import React, { useState } from "react";

const CustomTextField = ({
  type,
  name,
  value,
  placeholder,
  title,
  errors,
  onChange,
  onBlur,
  sx = {},
  rows,
  multiline,
  width = {},
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <>
      <Box sx={{ width: "100%", ...width,  }}>
        <Typography sx={{ color: "#000000", pt: 0.5, pb: 0.5,fontSize:"12px",fontWeight:"500" }}>
          {title}
        </Typography>
        <TextField
          type={
            type === "password" ? (showPassword ? "text" : "password") : type
          }
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          multiline={multiline}
          rows={rows}
          InputProps={{
            endAdornment:
              type === "password" ? (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff sx={{ color: "#000000" }} />
                    ) : (
                      <Visibility sx={{ color: "#000000" }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ) : null,
          }}
          sx={{
            "& .MuiOutlinedInput-notchedOutline ": {
              outline: "none",
              border: "none",
            },
            borderRadius: "20px",
            border: "1px solid #EAE8FF24",
            outline: "none",
            background: "#f3f3f3",
            color: "#FFFFFF",
            fontSize: "14px",
            width: "100%",
            ...sx,
          }}
        />
        {errors ? (
          <>
            <Typography
              sx={{ color: "red", fontSize: "12px", mt: 0.3, mb: 0.3 }}
            >
              {errors}
            </Typography>
          </>
        ) : null}
      </Box>
    </>
  );
};

export default CustomTextField;
